import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/store'

let routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginScreen.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/LogoutScreen.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeScreen.vue'),
    children: [
      {
        path: '/preview/:templateId',
        name: 'preview',
        component: () => import('../views/PreviewScreen.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/editor/:projectId',
        name: 'usereditor',
        component: () => import('../views/EditorScreen.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/templates',
        name: 'templates',
        component: () => import('../views/AllTemplateScreen.vue'),
        meta: {
          requiresAuth: true,
        },

      },
      // {
      //   path: '/credit',
      //   name: 'credit',
      //   component: () => import('../views/CreditScreen.vue'),
      //   meta: {
      //     requiresAuth: true,
      //   },
      // },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/template/:id',
    name: 'template',
    component: () => import('../views/TemplateScreen.vue'),
    children: [
      // {
      //   path: 'template-editor',
      //   name: 'template-editor',
      //   component: () => import('../views/TemplateEditorScreen.vue'),
      //   // meta: { keepAlive: true },
      //   props: true,
      // },
      {
        path: 'editor',
        name: 'editor',
        component: () => import('../views/EditorScreen.vue'),
        // meta: { keepAlive: true },
        props: true,
      },

    ],
    meta: { keepAlive: true }
  },

  {
    path: '/stucture-editor/',
    name: 'stucture-editor',
    component: () => import('../views/StructureEditorScreen.vue'),
    // meta: { keepAlive: true },
    props: true,
  },
  {
    path: '/stucture-preview/:id',
    name: 'stucture-preview',
    component: () => import('../views/PreviewScreen.vue'),
    // meta: { keepAlive: true },
    props: true,
  },
  {
    path: '/editorPlan',
    redirect: '/generate' // หรือจะเป็น NotFound ก็ได้
  },

  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterScreen.vue'),
    meta: {
      requiresAuth: true,
    },
  },



  {
    path: '/editorPlan/:api/:id',
    name: 'editorPlan',
    component: () => import('../views/EditorPlanScreen.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    name: 'start',
    component: () => import('../views/StartScreen.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFoundScreen.vue'),
    meta: {
      requiresAuth: false
    }
  }

];

// ฟังก์ชันเพิ่ม layout ใน meta
function addLayoutToRoute(route, parentLayout = 'default') {
  route.meta = route.meta || {};
  route.meta.layout = route.layout || parentLayout;

  if (route.children) {
    route.children = route.children.map(child =>
      addLayoutToRoute(child, route.meta.layout)
    );
  }
  return route;
}

routes = routes.map(route => addLayoutToRoute(route));

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to,) {
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' };
    }
    return { left: 0, top: 0, behavior: 'smooth' };
  },
});
router.beforeEach(() => {
  // ✅ ไม่ต้องตรวจสอบ token ที่นี่อีกแล้ว
  // ✅ ไม่ต้องเรียก validateToken
  // ✅ ปล่อยให้ route ไปต่อทุกกรณี
  return true;
});

export default router;
